// api/services/workspaceService.js
import api from '../client';

export const workspaceService = {
  // Get all workspaces
  getAllWorkspaces: async () => {
    try {
      const response = await api.get('/workspaces/');
      return response.data;
    } catch (error) {
      console.error('Error fetching workspaces:', error);
      throw error;
    }
  },

  // Create a new workspace
  createWorkspace: async (workspaceData) => {
    try {
      // Use FormData for file uploads if logo is present
      const formData = new FormData();
      formData.append('name', workspaceData.name);
      formData.append('url_name', workspaceData.url_name);
      if (workspaceData.description) {
        formData.append('description', workspaceData.description);
      }
      
      if (workspaceData.logo instanceof File) {
        formData.append('logo', workspaceData.logo);
      }

      const response = await api.post('/workspaces/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating workspace:', error);
      throw error;
    }
  },

  // Update a workspace (JSON fields, e.g. bi_agent_prompt)
  updateWorkspace: async (workspaceId, data) => {
    try {
      const response = await api.patch(`/workspaces/${workspaceId}/`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating workspace ${workspaceId}:`, error);
      throw error;
    }
  },

  // Get a specific workspace by ID
  getWorkspace: async (workspaceId) => {
    try {
      const response = await api.get(`/workspaces/${workspaceId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching workspace ${workspaceId}:`, error);
      throw error;
    }
  },

  // Get projects for a specific workspace
  getWorkspaceProjects: async (workspaceId) => {
    try {
      const response = await api.get(`/workspaces/${workspaceId}/projects/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching projects for workspace ${workspaceId}:`, error);
      throw error;
    }
  },

  // Delete a workspace
  deleteWorkspace: async (workspaceId) => {
    try {
      await api.delete(`/workspaces/${workspaceId}/`);
      return true;
    } catch (error) {
      console.error(`Error deleting workspace ${workspaceId}:`, error);
      throw error;
    }
  },

  // Check URL name availability
  checkUrlNameAvailability: async (urlName) => {
    try {
      const response = await api.get(`/workspaces/check_url_name/`, {
        params: { url_name: urlName }
      });
      return response.data.available;
    } catch (error) {
      console.error('Error checking URL name:', error);
      return true; // Fail open or handle error appropriately
    }
  }
};

export default workspaceService;